<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("trace.title") }}</h1>
    <form>
      <div class="w-50 mb-3">
        <b-card>
          <form>
            <b-form-group
              id="lineListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('trace.label_line')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="lineListSearch" :options="lines" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="processListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('trace.label_process')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="processListSearch" :options="processes" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="machineListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('trace.label_machine')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="machineListSearch" :options="machines" class="mb-3" ></b-form-select>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("trace.button_search") }}</b-button>
            </div>
          </form>
        </b-card>
      </div>
    </form>
    <div v-if="isSearch">
      <b-card class="mb-3">
        <h2
          :class="showCollapse ? 'collapsed' : null"
          :aria-expanded="showCollapse ? 'true' : 'false'"
          aria-controls="collapse-12"
          @click="showCollapse = !showCollapse"
        >{{ $i18n.t("trace.label_trace_register") }}</h2>
        <b-collapse id="collapse-12" v-model="showCollapse" class="mt-3">
          <b-row>
            <b-col sm="5" md="1" class="my-1">
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
            <b-col sm="7" md="11" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="procItems"
            :fields="procFields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :per-page="perPage"
          >
            <template v-slot:cell(user)="row">
              <b-link @click="linkToTraceEditUser(row.item, row.index)">{{ row.item.user }}</b-link>
            </template>
            <template v-slot:cell(parts)="row">
              <b-link @click="linkToTraceEditParts(row.item, row.index)">{{ row.item.parts }}</b-link>
            </template>
            <template v-slot:cell(tool)="row">
              <b-link @click="linkToTraceEditTool(row.item, row.index)">{{ row.item.tool }}</b-link>
            </template>
          </b-table>
        </b-collapse>
      </b-card>
    </div>
    <!-- エラーメッセージ用 -->
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      totalRows: 1,
      lineListSearch: null,
      processListSearch: null,
      machineListSearch: null,
      currentPage: 1,
      lines: [
        { value: null, text: this.$i18n.t('trace.label_all_line') }
      ],
      processes: [
        { value: null, text: this.$i18n.t('trace.label_all_process') }
      ],
      machines: [
        { value: null, text: this.$i18n.t('trace.label_all_machine') }
      ],
      procFields: [
        { key: 'line', label: this.$i18n.t('trace.label_line'), sortable: true },
        { key: 'process', label: this.$i18n.t('trace.label_process'), sortable: true },
        { key: 'machine', label: this.$i18n.t('trace.label_machine'), sortable: true },
        { key: 'user', label: this.$i18n.t('trace.label_operator_count'), sortable: true },
        { key: 'parts', label: this.$i18n.t('trace.label_parts_count'), sortable: true },
        { key: 'tool', label: this.$i18n.t('trace.label_tool_count'), sortable: true }
      ],
      procItems: [
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      showCollapse: true,
      noCollapse: true,
      isSearch: false,
      from: '',
      to: '',
      errMsg: null,
      errSbj: null
    }
  },
  created () {
    this.searchLine()
    this.searchProcess()
    this.searchMachine()
  },
  methods: {
    search: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      // パラメータ取得
      var lineId = this.lineListSearch
      var processId = this.processListSearch
      var machineId = this.machineListSearch
      var body = {}
      if (lineId != null) {
        body.line = String(lineId)
      }
      if (processId != null) {
        body.process = String(processId)
      }
      if (machineId != null) {
        body.machine = String(machineId)
      }

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/trace/selectCount', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            // 取得データセット
            var countList = res.data.list
            var counts = []
            // 整形
            for (var i = 0; i < countList.length; i++) {
              var count = {}
              count.lineId = countList[i].lineId
              count.line = countList[i].lineName
              count.processId = countList[i].processId
              count.process = countList[i].processName
              count.machineId = countList[i].machineId
              count.machine = countList[i].machineName
              count.user = countList[i].userCount
              count.parts = countList[i].partsCount
              count.tool = countList[i].toolCount
              counts.push(count)
            }
            // 一旦データクリア
            this.procItems.splice(0)
            // データセット
            this.procItems.splice(0, 0, ...counts)
            // ページング設定
            this.totalRows = countList.length
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })

      console.log(this.from)
      this.isSearch = true
    },
    // ラインプルダウン取得
    searchLine: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var linebody = {}
      linebody.efFlg = '1'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/line/select', linebody, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var lineList = res.data.lineInfo
            var lines = []
            // 整形
            for (var i = 0; i < lineList.length; i++) {
              var option = {}
              option.value = lineList[i].line_id
              option.text = lineList[i].line_name + ' (' + lineList[i].base_name + ')'
              lines.push(option)
            }
            // 一旦データクリア
            this.lines.splice(1)
            // データセット
            this.lines.splice(1, 0, ...lines)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    // 工程プルダウン取得
    searchProcess: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var processbody = {}
      processbody.efFlg = '1'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/process/select', processbody, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var processList = res.data.processInfo
            var processes = []
            // 整形
            for (var i = 0; i < processList.length; i++) {
              var option = {}
              option.value = processList[i].process_id
              option.text = processList[i].process_name
              processes.push(option)
            }
            // 一旦データクリア
            this.processes.splice(1)
            // データセット
            this.processes.splice(1, 0, ...processes)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    // 設備プルダウン取得
    searchMachine: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var machinebody = {}
      machinebody.efFlg = '1'
      machinebody.machineName = ''

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/select', machinebody, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var machineList = res.data.machineInfo
            var machines = []
            // 整形
            for (var i = 0; i < machineList.length; i++) {
              var option = {}
              option.value = machineList[i].machine_id
              option.text = machineList[i].machine_name
              machines.push(option)
            }
            // 一旦データクリア
            this.machines.splice(1)
            // データセット
            this.machines.splice(1, 0, ...machines)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    linkToTraceEditUser: function (item, index) {
      this.$store.store.state.machineId = item.machineId
      this.$store.store.state.machineName = item.machineName
      this.$router.push({ path: 'tracementeEdit', query: {type: '1'} })
    },
    linkToTraceEditParts: function (item, index) {
      this.$store.store.state.machineId = item.machineId
      this.$store.store.state.machineName = item.machineName
      this.$router.push({ path: 'tracementeEdit', query: {type: '2'} })
    },
    linkToTraceEditTool: function (item, index) {
      this.$store.store.state.machineId = item.machineId
      this.$store.store.state.machineName = item.machineName
      this.$router.push({ path: 'tracementeEdit', query: {type: '3'} })
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Tracemente.vue